export default "__VITE_ASSET__523cdebb__"